<template>
  <el-table
    :data="list"
    stripe
    v-loading="loading"
    @selection-change="handleSelectionChange"
  >
    <template v-for="column, index in tableColumns">
      <el-table-column  :key="column.props" v-if="column.props === 'selection'" type="selection" :width="column.width" :align="column.align"></el-table-column>
      <!-- TODO: 待优化 -->
      <el-table-column
        v-else
        :key="index"
        :prop="column.props"
        :align="column.align ||'left'"
        :label="column.label"
        :width="column.width"
        :min-width="column.minWidth"
        :fixed="column.fixed"
      >
        <template slot-scope="{row,$index}">
          <slot :name="column.props" :row="row">
            <p v-if="$index === list.length - 1" style="color: red">
              <span v-if="index === 0">
                汇总
              </span>
              <span v-else>
                {{ formatterColumnData(row, column) }}
              </span>
            </p>
            <p v-else>
              {{ formatterColumnData(row, column) }}
            </p>
          </slot>
        </template>
      </el-table-column>
    </template>
  </el-table>
</template>
<script>

const columns = Object.freeze([
  { props: 'receptionStaffName', label: '接待人员', width: 120 },
  { props: 'receptionNumber', label: '接待数量', width: 120 },
  { props: 'receptionRate', label: '同期环比(%)', width: 120 },
  { props: 'receptionAverageTime', label: '平均接待时长(分钟)', width: 160 },
  { props: 'customerNumber', label: '客户数量', width: 120 },
  { props: 'receptionRetentionRate', label: '接待留资率(%)', width: 120 },
  { props: 'secondaryStoreRate', label: '二次到店率(%)', width: 120 },
  { props: 'secondaryStoreSamePeriodRate', label: '同期环比(%)', width: 120 },
  { props: 'testDriveRate', label: '试驾率(%)', width: 120 },
  { props: 'orderNumber', label: '客流订单数', width: 120 },
  { props: 'orderSamePeriodRate', label: '同期环比(%)', width: 120 },
  { props: 'orderRate', label: '转订率(%)', width: 120 },
  { props: 'dealNumber', label: '成交', width: 120 },
  { props: 'dealSamePeriodRate', label: '同期环比(%)', width: 120 },
  { props: 'dealRate', label: '成交率(%)', width: 120 },
  { props: 'dealName', label: '门店名称', minWidth: 120, width: 120 },
])

export default {
  name: 'CustomerStatisticsList',
  props: {
    list: {
      type: Array,
      default: () => []
    },
    loading: {
      type: Boolean,
      default: false
    },
  },
  data() {
    return {
      tableColumns: columns
    }
  },
  methods: {
    formatterColumnData(row, column) {
      if (typeof column.formatter ===  'function') {
        return column.formatter(row, column.props)
      }
      if (row[column.props] === -9999.99){
        return '--'
      }
      return row[column.props]
    },
    // 勾选选择框
    handleSelectionChange(val){
      console.log(val, 'handleSelectionChange===')
    }
  }
}
</script>
<style lang="scss" scoped>
</style>